import Header from "@/components/common/Header";
import Container from "../../atoms/Container";
import Footer from "@/components/Footer/Footer";
import Heading from "../../atoms/heading/Heading";
import Link from "next/link";

const CookiesPolicy = () => {
  return (
    <div className="w-full bg-white md:bg-neutral-5 min-h-screen">
      <Header showLocation={false} />
      <Container type="type1" className="mt-9">
        <div className="px-4 md:px-0">
          <div className="text-center">
            <Heading type="h1">COOKIE POLICY</Heading>
          </div>

          <Heading type="h4" className="mt-4">
            1 .Background
          </Heading>

          <div className="mt-3">
            1.1   We use cookies on our website available at   <Link href="/services">
          <a className="underline text-blue-600">{window.location.host}/services </a>
        </Link> to distinguish you from other users of the Website. Cookies help us improve the Website and provide you with a good user-experience when you browse the Website.
          </div>

          <div className="mt-3">
            1.2   A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer, if you agree or where it is necessary to make the Website available and accessible to you. Cookies contain information that is transferred to your computer’s hard drive and allow us to recognise you and make your visit easier and more useful when you revisit the Website.
          </div>

          <div className="mt-3">
            1.3  In the tables below, you will see a description of each cookie that we use and how it functions. In general, please read our privacy policy available at {window.location.origin}/privacy-policy to understand our data collection and processing practices.
          </div>
          <Heading type="h4" className="mt-4">
            2. Types of Cookies
          </Heading>

          <div className="mt-3">
            2.1  We use the following types of cookies:
          </div>
          <ol style={{ listStyleType: "lower-roman" }} className='ml-8'>
            <li>
              <strong>Essential Cookies. </strong> These cookies are sometimes called “strictly necessary” cookies and are required for the operation of our Website.
            </li>
            <li>
              <strong>Analytical or Performance Cookies. </strong> These allow us to recognise and count the number of visitors and to see how visitors move around the Website. This helps us improve the way our Website works (for example, by ensuring that users find what they are looking for easily).
            </li>
            <li>
              <strong>Functionality Cookies. </strong> These are used to recognise you when you return to the Website. This enables us to personalise our content for you, greet you by name, and remember your preferences (for example, your region).
            </li>
            <li>
              <strong>Targeting cookies. </strong> These cookies record your visit to the Website, the pages you have visited, and the links you have followed.
            </li>
          </ol>
          <div className="mt-3">
            2.2  Additionally, please note that third parties may also use cookies on our Website, over which we have no control. These named third parties may include, for example, advertising networks and providers of external services like web traffic analysis services. These third party cookies are likely to be performance cookies or targeting cookies.
          </div>
          <div className="mt-3">
            2.3  Management of Cookies: There are many ways through which you can manage your cookies. Some way in which you may manage cookies include:
          </div>
          <ol style={{ listStyleType: "lower-roman" }} className='ml-8'>
            <li>   refusing to consent to cookies on the Website;
            </li>
            <li>   disabling the use of cookies through your browser settings; or
            </li>
            <li>   using cookie management tools to disable our cookies or third party cookies.
            </li>
          </ol>
          <div className="mt-3">
            You can block cookies by activating the setting on your browser that permits you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies), you may not be able to access all or parts of our Website.
          </div>

        </div>
      </Container>
      <Footer />
    </div>
  )
}

export default CookiesPolicy